@if (messageBars().length > 0) {
  <div class="absolute p-4 bottom-0 w-full sm:w-auto sm:top-4 sm:right-4 sm:bottom-auto z-[10000]">
    <div class="flex flex-col gap-2">
      @for (messageBar of messageBars(); track messageBar.id) {
        <div>
          <soft-message-bar [config]="messageBar"
                            (dismiss)="onDismiss(messageBar.id)"></soft-message-bar>
        </div>
      }
    </div>
  </div>
}

